module.exports = __webpack_public_path__ + "static/media/Logo.b3b385f9.svg";